import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useAccountStore } from "@/features/account-management";
import { accountApi } from "./account.api";
import { accountKeys } from "./account.keys";

export const useGetAccountQuery = () => {
  const query = useQuery({
    queryKey: accountKeys.account,
    queryFn: () => accountApi.getAccount(),
  });

  useEffect(() => {
    if (!query.data) return;
    useAccountStore.getState().setAccount(query.data);
  }, [query.data]);

  return query;
};

export const useGetInvitationLinkQuery = () => {
  return useQuery({
    queryKey: accountKeys.invitationLink,
    queryFn: () => accountApi.getInvitationLink(),
  });
};

export const useGetTokenQuery = () => {
  return useQuery({
    queryKey: accountKeys.token,
    queryFn: () => accountApi.getToken(),
  });
};

export const useGetInvoicesQuery = () => {
  return useQuery({
    queryKey: accountKeys.invoices,
    queryFn: () => accountApi.getInvoices(),
  });
};

export const useGetCancellationDiscountQuery = () => {
  return useQuery({
    queryKey: accountKeys.cancellationDiscount,
    queryFn: () => accountApi.getCancelationDiscount(),
  });
};

export const useVerifyClaimDiscountEligibilityQuery = () => {
  return useQuery({
    queryKey: accountKeys.discountEligibility,
    queryFn: () => accountApi.verifyClaimDiscountEligibility(),
  });
};
